module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/BattleList/images/divider-shadow.9603bf73.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/BattleList/images/divider-shadow.png
// module id = 3212
// module chunks = 11